import React, { Component, useEffect, useState } from "react";
import Form from "../../../comman/form";
import config from "../../../config.json";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Joi from "joi-browser";
import Swal from "sweetalert2";
import AddSubcontractor from "../AddSubcontractor";
import { useDispatch, useSelector } from "react-redux";
import { getPartnerListByType, getSubcontractorPartners, loadPartnerListByType, loadSubcontractorPartners } from "../../../app/store/partner";
import { getApplicationData } from "../../../app/store/application";
import { candidateUpdated, getCandidateUpatedStatus, updateNewCandidate } from "../../../app/store/candidate";
import { addNewRates, getRateUpdatedStatus, ratesReceived, updateRate } from "../../../app/store/rates";
import { getAlert } from "../../../services/appAlerts";
import { loadSubcontractors } from "../../../app/store/subcontractor";
import { getDataTypeApplicationReports, loadDataTypeApplicationReports } from "../../../app/store/reports";
import { getCurrentUser } from "../../../app/store/auth";

const Subcontractor = (props) => {

  const { candidateObj, entityType, actType, handleNextTab, updateSelectedObject, rateHistory } = props;

  const [subcontractors, setSubcontractors] = useState([]);
  const [selectedSubcontractorId, setSelectedSubcontractorId] = useState(0);
  const [subcontractorRate, setSubcontractorRate] = useState(0);
  const [subcontractorLessFee, setSubcontractorLessFee] = useState(0);
  const [subcontractorFinalRate, setSubcontractorFinalRate] = useState(0);
  const [partnerType, setPartnerType] = useState("Sub-Contractors");
  const [aworkfinityApp, setAworkfinityApp] = useState(null);
  const [showHideSub, setShowHideSub] = useState(false);
  const [showDetailSub, setShowDetailSub] = useState(false);
  const [allReportData, setAllReportData] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [selectedJsonData, setSelectedJsonData] = useState("");
  const [partnerListByType, setPartnerListByType] = useState([]);
  const [compName, setCompName] = useState("");
  const [btnUnable, setBtnUnable] = useState(false);

  const subcontractorPartnersSelector = useSelector(getSubcontractorPartners);
  const rateUpdatedStatusSelector = useSelector(getRateUpdatedStatus)
  const partnerListByTypeSelector = useSelector(getPartnerListByType);
  const dataTypeApplicationReportsSelector = useSelector(getDataTypeApplicationReports);

  const candidateUpatedStatusSelector = useSelector(getCandidateUpatedStatus)

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  useEffect(() => {
    dispatch(loadSubcontractorPartners(partnerType))
    //dispatch(loadPartnerListByType(partnerType));
  }, []);

  useEffect(() => {
    if (subcontractorPartnersSelector.length > 0) {
      setSubcontractors(subcontractorPartnersSelector);
      dispatch(loadDataTypeApplicationReports());
    }
  }, [subcontractorPartnersSelector]);

  useEffect(() => {
    setPartnerListByType(partnerListByTypeSelector);
  }, [partnerListByTypeSelector]);

  useEffect(() => {
    if (selectedSubcontractorId > 0) {
      dispatch(loadPartnerListByType(partnerType, selectedSubcontractorId));
    }
  }, [selectedSubcontractorId]);

  useEffect(() => {
    if (selectedSubcontractorId > 0 && partnerListByType.length > 0) {
      const partner = partnerListByType.filter((x) => x.fuid === parseInt(selectedSubcontractorId));
      if (partner.length > 0) {
        setSelectedJsonData(partner[0].contact1?.performerData || "");
      } else {
        setSelectedJsonData("");
      }
    } else {
      setSelectedJsonData("");
    }
  }, [selectedSubcontractorId, partnerListByType]);

  useEffect(() => {
    if (dataTypeApplicationReportsSelector.length > 0) {
      const rptDt = dataTypeApplicationReportsSelector;
      setAllReportData(rptDt);
    }
  }, [dataTypeApplicationReportsSelector]);

  useEffect(() => {
    if (!candidateObj)
      setSelectedSubcontractorId(0);

    if (candidateObj?.subcontractor)
      setSelectedSubcontractorId(candidateObj.validId);

    const data = { ...rateHistory[rateHistory.length - 1] };
    if (data["subcontractorRate"]) {
      setSubcontractorFinalRate(data["subcontractorRate"])
      setSubcontractorLessFee(data["subcontractorTechFee"] || 0)
      setSubcontractorRate(parseFloat(data["subcontractorRate"]) + parseFloat(data["subcontractorTechFee"] || 0))
    } else if (actType === "edit") {
      setSubcontractorFinalRate("")
      setSubcontractorLessFee("")
      setSubcontractorRate("")
    }

    if (candidateObj?.performerData) {
      const obj = getApplicationData(candidateObj.performerData);
      if (obj?.aWorkfinityApp)
        setAworkfinityApp(obj.aWorkfinityApp);
    }
    setBtnUnable(false)

  }, [candidateObj, rateHistory]);

  useEffect(() => {
    if (allReportData.length > 0) {
      let rptData = [];
      rptData = allReportData.filter((x) => x.name === "SubcontractorEnrollmentForm");
      setReportData(rptData);
    }

  }, [allReportData])

  const handleSubmit = (btnType) => {
    if (entityType !== "C2C Basis") {
      getAlert("", "Subcontractor can only be assigned to C2C candidates", "warning");
      return;
    }

    if (!candidateObj?.performerid) {
      getAlert("", "Save candidate details before assigning subcontractor", "warning");
      return;
    }

    const NewAWorkfinityApp = { ...aworkfinityApp };
    const appName = Object.keys(NewAWorkfinityApp)[1];
    const aWorkfinityAppEntity = NewAWorkfinityApp[appName];
    if (selectedSubcontractorId > 0) {
      const subs = subcontractors.filter(x => x.fuid === parseInt(selectedSubcontractorId));
      if (subs.length > 0) {
        const subDetails = JSON.parse(subs[0].createdBy);
        const appEntity = subDetails[appName];
        aWorkfinityAppEntity["subcontractorenrollmentform"] = appEntity["subcontractorenrollmentform"];
        NewAWorkfinityApp[appName] = aWorkfinityAppEntity;
        setAworkfinityApp(NewAWorkfinityApp);
        setBtnUnable(true)
        const formData = new FormData();
        formData.append("appEntity", JSON.stringify(NewAWorkfinityApp));
        formData.append("subcontractor", selectedSubcontractorId);
        formData.append("recruiter", "");
        formData.append("perfId", candidateObj.performerid);
        dispatch(updateNewCandidate(formData));
        // if (actType === "edit") {
        //   updateSelectedObject(candidateObj.performerid, aworkfinityApp);
        // } else {
        //   updateSelectedObject(candidateObj.performerid);
        // }
        //handleSaveRates();

        // if (actType === "edit"){
        //   getAlert("", "Updated Successfully", "success");
        // }
        // else{
        //   getAlert("", "Saved Successfully", "success");
        // }
        //updateSelectedObject(candidateObj.performerid);
        //dispatch(ratesReceived([]));
        //handleNextTab(btnType);
        setCompName("subcontractor")
      }
    }

  };


  const handleUpdaterates = () => {
    const data = { ...rateHistory[rateHistory.length - 1] };
    const rateObj = {
      performerId: candidateObj.performerid,
      id: data.id,
      addedBy: currentUser.id,
      notes: data["notes"],
      subcontractorRate: subcontractorFinalRate || 0,
      SubcontractorTechFee: subcontractorLessFee || 0,
      CandidateTechFee: data["candidateTechFee"] || 0,
      RecruiterTechFee: data["recruiterTechFee"] || 0,
      AgencyTechFee: data["agencyTechFee"] || 0,
      recruiterRate: data["recruiterRate"] || 0,
      candidateRate: data["candidateRate"] || 0,
      agencyRate: data["agencyRate"] || 0,
      candidateEffectiveDate: data["candidateEffectiveDate"] || new Date().toISOString(),
      agencyEffectiveDate: data["agencyEffectiveDate"] || new Date().toISOString(),
      subcontractorEffectiveDate: data["subcontractorEffectiveDate"] || new Date().toISOString(),
      recruiterEffectiveDate: data["recruiterEffectiveDate"] || new Date().toISOString(),
    };
    dispatch(addNewRates(rateObj))
  }

  useEffect(() => {
    if (candidateUpatedStatusSelector && compName === "subcontractor") {
      setCompName("");
      if (actType === "edit") {
        getAlert("", "Updated Successfully", "success");
        handleUpdaterates()
      }
      else {
        getAlert("", "Saved Successfully", "success");
      }

      updateSelectedObject(candidateObj.performerid, aworkfinityApp);
      handleSaveRates();
      dispatch(candidateUpdated(null));
      //handleNextTab(btnType);
    }
  }, [candidateUpatedStatusSelector])

  const getAttributeValue = (d, t, att) => {
    if (d?.appData && d.appData === "") return "";
    const itemValues = JSON.parse(d.appData);
    const appShortName = Object.keys(itemValues)[1];
    const items = itemValues[appShortName][t.name.toLowerCase()];
    return items && items["@" + att];
  };

  const getAttribute = (t) => {
    if (t?.data && t?.data !== "") {
      const items = JSON.parse(t.data);
      return items;
    }
    return [];
  };

  const handleAddEditSubcontractor = (data) => {
    if (data === "exit") {
      setShowHideSub(!showHideSub)
      dispatch(loadSubcontractorPartners(partnerType))
      //dispatch(loadPartnerListByType(partnerType))
    }
  }

  const handleSaveRates = () => {
    const frmData = new FormData();
    frmData.append("id", candidateObj.performerid);
    frmData.append("type", "subcontractor");
    frmData.append("subRate", subcontractorFinalRate || 0);
    frmData.append("subTechFee", subcontractorLessFee || 0);
    dispatch(updateRate(frmData));
  };

  useEffect(() => {
    const rate = parseFloat(subcontractorRate) || 0;
    const lessFee = parseFloat(subcontractorLessFee) || 0;

    const finalRate = rate - lessFee;
    setSubcontractorFinalRate(isNaN(finalRate) ? 0 : finalRate);
  }, [subcontractorRate, subcontractorLessFee]);

  const ChangeRatePerHour = (rateVal) => {
    const rate = parseFloat(rateVal) || 0;
    setSubcontractorRate(rate);
  };

  const ChangeLessTechFee = (rateVal) => {
    const fee = parseFloat(rateVal) || 0;
    if (fee <= subcontractorRate || isNaN(fee)) {
      setSubcontractorLessFee(fee);
    }
  };

  const handleSubShow = () => {
    setShowHideSub(!showHideSub)
    setShowDetailSub(false)
  }

  const handleSubDetails = () => {
    setShowHideSub(false);
    setShowDetailSub(!showDetailSub);
  };

  const handleChangeSubcontractor = ({ currentTarget: input }) => {
    const id = input.value;
    setSelectedSubcontractorId(parseInt(id));
    setShowHideSub(false);
    setShowDetailSub(false);
  }

  const btnDisabled = selectedSubcontractorId > 0 && subcontractorRate > 0;

  if (entityType !== "C2C Basis") {
    return (
      <div className="col-md-12">
        <div className="alert alert-warning mb-0">
          Subcontractor assignment is available only for C2C candidates.
        </div>
      </div>
    );
  }

  return (
    <div className="wf-subcontractor-tab-container col-md-12">
      <style>{`
        /* Premium custom styles for Subcontractor Tab */
        .wf-subcontractor-tab-container .btn-outline-primary-custom {
          color: #2563eb !important;
          border: 1.5px solid #cbd5e1 !important;
          background: #ffffff !important;
          font-weight: 700 !important;
          font-size: 12.5px !important;
          padding: 8px 16px !important;
          border-radius: 8px !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 8px !important;
          box-shadow: 0 1px 3px rgba(0,0,0,0.05) !important;
        }
        .wf-subcontractor-tab-container .btn-outline-primary-custom:hover {
          color: #2563eb !important;
          border-color: #2563eb !important;
          background: #eff6ff !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 10px rgba(37, 99, 235, 0.08) !important;
        }

        .wf-subcontractor-tab-container .btn-outline-info-custom {
          color: #0f766e !important;
          border: 1.5px solid #cbd5e1 !important;
          background: #ffffff !important;
          font-weight: 700 !important;
          font-size: 12.5px !important;
          padding: 8px 16px !important;
          border-radius: 8px !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 8px !important;
          box-shadow: 0 1px 3px rgba(0,0,0,0.05) !important;
        }
        .wf-subcontractor-tab-container .btn-outline-info-custom:hover {
          color: #0f766e !important;
          border-color: #0f766e !important;
          background: #f0fdfa !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 10px rgba(15, 118, 110, 0.08) !important;
        }

        .wf-subcontractor-tab-container .wf-info-banner {
          background: #eff6ff !important;
          border-left: 4px solid #3b82f6 !important;
          padding: 12px 16px !important;
          border-radius: 0 8px 8px 0 !important;
          box-shadow: 0 1px 3px rgba(15, 23, 42, 0.03) !important;
          margin-bottom: 20px !important;
        }
        .wf-subcontractor-tab-container .wf-info-banner-icon {
          color: #2563eb !important;
          font-size: 15px !important;
          flex-shrink: 0 !important;
        }
        .wf-subcontractor-tab-container .wf-info-banner-text {
          color: #1e3a8a !important;
          font-size: 12.5px !important;
          font-weight: 600 !important;
          line-height: 1.5 !important;
        }

        .wf-subcontractor-tab-container label {
          font-size: 11px !important;
          font-weight: 700 !important;
          color: #64748b !important;
          text-transform: uppercase !important;
          letter-spacing: 0.7px !important;
          margin-bottom: 6px !important;
          display: flex !important;
          align-items: center !important;
          gap: 5px !important;
        }

        .wf-subcontractor-tab-container .wf-input-wrap {
          position: relative !important;
          width: 100% !important;
        }
        .wf-subcontractor-tab-container .wf-input-wrap .wf-input-icon {
          position: absolute !important;
          left: 12px !important;
          top: 50% !important;
          transform: translateY(-50%) !important;
          color: #94a3b8 !important;
          font-size: 13px !important;
          pointer-events: none !important;
          transition: color 0.2s ease !important;
          z-index: 10 !important;
        }
        .wf-subcontractor-tab-container .wf-input-wrap:focus-within .wf-input-icon {
          color: #2563eb !important;
        }

        .wf-subcontractor-tab-container .form-control {
          border-radius: 9px !important;
          border: 1.5px solid #cbd5e1 !important;
          padding: 8px 13px 8px 35px !important; /* Left padding prevents icon-text overlap */
          font-size: 13.5px !important;
          color: #1e293b !important;
          background: #ffffff !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03) !important;
          width: 100% !important;
        }
        .wf-subcontractor-tab-container .form-control:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1), 0 2px 6px -1px rgba(37, 99, 235, 0.08) !important;
          outline: none !important;
          background: #fafbff !important;
        }
        .wf-subcontractor-tab-container select.form-control {
          appearance: none !important;
          -webkit-appearance: none !important;
          background: #ffffff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2394a3b8'/%3E%3C/svg%3E") no-repeat right 12px center !important;
          padding-right: 32px !important;
        }
        .wf-subcontractor-tab-container select.form-control:focus {
          background: #fafbff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2394a3b8'/%3E%3C/svg%3E") no-repeat right 12px center !important;
        }

        .wf-subcontractor-tab-container .btn-primary-custom {
          background: #2563eb !important;
          border: 1px solid #2563eb !important;
          color: #ffffff !important;
          font-weight: 700 !important;
          font-size: 13.5px !important;
          padding: 8px 24px !important;
          border-radius: 8px !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.12), 0 2px 4px -1px rgba(37, 99, 235, 0.06) !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 8px !important;
        }
        .wf-subcontractor-tab-container .btn-primary-custom:hover:not(:disabled) {
          background: #1d4ed8 !important;
          border-color: #1d4ed8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 10px 15px -3px rgba(37, 99, 235, 0.18), 0 4px 6px -2px rgba(37, 99, 235, 0.08) !important;
        }
        .wf-subcontractor-tab-container .btn-primary-custom:disabled {
          background: #e2e8f0 !important;
          border-color: #cbd5e1 !important;
          color: #94a3b8 !important;
          cursor: not-allowed !important;
          box-shadow: none !important;
        }

        .wf-subcontractor-tab-container .wf-detail-table-card {
          border: 1px solid #e2e8f0 !important;
          border-radius: 10px !important;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03) !important;
          overflow: hidden !important;
          margin-top: 20px !important;
        }
        .wf-subcontractor-tab-container .wf-detail-table-card .card-header {
          background: #f8fafc !important;
          border-bottom: 1px solid #e2e8f0 !important;
          padding: 12px 16px !important;
        }
        .wf-subcontractor-tab-container .wf-detail-table {
          width: 100% !important;
          border-collapse: collapse !important;
        }
        .wf-subcontractor-tab-container .wf-detail-table td {
          padding: 10px 16px !important;
          border-bottom: 1px solid #f1f5f9 !important;
          font-size: 13px !important;
          vertical-align: middle !important;
        }
        .wf-subcontractor-tab-container .wf-detail-table td.wf-detail-label {
          background-color: #f8fafc !important;
          font-weight: 700 !important;
          color: #475569 !important;
          width: 20% !important;
          text-transform: uppercase !important;
          font-size: 10.5px !important;
          letter-spacing: 0.6px !important;
        }
        .wf-subcontractor-tab-container .wf-detail-table td.wf-detail-value {
          color: #1e293b !important;
          width: 30% !important;
          font-weight: 500 !important;
        }
      `}</style>

      <div className="row">
        {/* Action Button Toolbar */}
        <div className="wf-sub-action-toolbar d-flex align-items-center mb-4 gap-3 pl-3 pr-3 w-100">
          <button
            type="button"
            className="btn-outline-primary-custom mr-3"
            onClick={() => handleSubShow()}
          >
            <i className="fa fa-plus-circle" /> Add New Subcontractor
          </button>
          {selectedSubcontractorId ? (
            <button
              type="button"
              className="btn-outline-info-custom"
              onClick={() => handleSubDetails()}
            >
              <i className={`fa ${showDetailSub ? "fa-eye-slash" : "fa-eye"}`} />
              {showDetailSub ? "Hide Subcontractor Details" : "View Subcontractor Details"}
            </button>
          ) : null}
        </div>

        {!showHideSub ? (
          <>
            {/* Info Message Banner */}
            <div className="col-md-12 pl-3 pr-3">
              <div className="wf-info-banner d-flex align-items-center gap-3">
                <i className="fa fa-info-circle wf-info-banner-icon" />
                <span className="wf-info-banner-text">
                  To assign a subcontractor to this candidate, select the subcontractor from the dropdown and configure the rates below.
                </span>
              </div>
            </div>

            {/* Form Fields Grid */}
            <div className="col-md-3 form-group">
              <label htmlFor="subcontractor">
                Select Subcontractor
              </label>
              <div className="wf-input-wrap">
                <i className="fa fa-handshake-o wf-input-icon" />
                <select
                  name="subcontractor"
                  id="subcontractor"
                  className="form-control"
                  onChange={handleChangeSubcontractor}
                  value={selectedSubcontractorId}
                >
                  <option value="">Select Subcontractor</option>
                  {subcontractors.map((item) => (
                    <option key={item.fuid} value={item.fuid}>{item.label}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-md-3 form-group">
              <label htmlFor="rate">
                Rate/Hour-Paid to Subcontractor $
              </label>
              <div className="wf-input-wrap">
                <i className="fa fa-usd wf-input-icon" />
                <input
                  className="form-control"
                  type="number"
                  name="rate"
                  id="rate"
                  value={subcontractorRate}
                  disabled={!selectedSubcontractorId}
                  onChange={({ currentTarget }) => ChangeRatePerHour(currentTarget.value)}
                  placeholder="0.00"
                />
              </div>
            </div>

            <div className="col-md-3 form-group">
              <label htmlFor="SubcontractorTechFee">
                Less Tech Fee $
              </label>
              <div className="wf-input-wrap">
                <i className="fa fa-calculator wf-input-icon" />
                <input
                  className="form-control"
                  type="number"
                  name="SubcontractorTechFee"
                  id="SubcontractorTechFee"
                  value={subcontractorLessFee}
                  disabled={!selectedSubcontractorId}
                  onChange={({ currentTarget }) => ChangeLessTechFee(currentTarget.value)}
                  placeholder="0.00"
                />
              </div>
            </div>

            <div className="col-md-3 form-group">
              <label htmlFor="FinalValue">
                Final Subcontractor Rate $
              </label>
              <div className="wf-input-wrap">
                <i className="fa fa-check-circle-o wf-input-icon" />
                <input
                  className="form-control"
                  type="number"
                  name="FinalValue"
                  disabled
                  id="FinalValue"
                  value={subcontractorFinalRate}
                  placeholder="0.00"
                  style={{ background: "#f8fafc", color: "#475569", fontWeight: "700" }}
                />
              </div>
            </div>

            {/* Save Buttons */}
            <div className="col-md-12 text-center form-group mt-4 mb-4">
              <button
                type="button"
                className="btn-primary-custom wf-save-assignment-btn"
                disabled={!btnDisabled || btnUnable}
                onClick={() => handleSubmit("save")}
              >
                <i className="fa fa-check" /> Save Subcontractor Assignment
              </button>
              {actType !== "edit" && (
                <button
                  type="button"
                  className="btn-primary-custom ml-2"
                  onClick={() => handleNextTab("next")}
                >
                  <i className="fa fa-arrow-right" /> Next
                </button>
              )}
            </div>

            {/* Subcontractor details panel */}
            {showDetailSub && (
              <div className="col-md-12 pl-3 pr-3">
                <div className="wf-detail-table-card">
                  <div className="card-header py-2 px-3">
                    <h4 className="mb-0 text-slate-700" style={{ fontSize: "13px", fontWeight: "700" }}>
                      <i className="fa fa-briefcase mr-2" style={{ color: "#2563eb" }} /> Subcontractor Firm Details
                    </h4>
                  </div>
                  <div className="table-responsive">
                    <table className="wf-detail-table">
                      <tbody>
                        {selectedJsonData && reportData.map((t, tIdx) => {
                          const attrs = getAttribute(t);
                          const pairs = [];
                          for (let i = 0; i < attrs.length; i += 2) {
                            pairs.push(attrs.slice(i, i + 2));
                          }
                          return pairs.map((pair, pIdx) => (
                            <tr key={pIdx}>
                              {/* Column 1 */}
                              <td className="wf-detail-label">
                                {pair[0].Label}
                              </td>
                              <td className="wf-detail-value">
                                {getAttributeValue({ appData: selectedJsonData }, t, pair[0].Name) || "N/A"}
                              </td>

                              {/* Column 2 */}
                              {pair[1] ? (
                                <>
                                  <td className="wf-detail-label">
                                    {pair[1].Label}
                                  </td>
                                  <td className="wf-detail-value">
                                    {getAttributeValue({ appData: selectedJsonData }, t, pair[1].Name) || "N/A"}
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td className="wf-detail-label" />
                                  <td className="wf-detail-value" />
                                </>
                              )}
                            </tr>
                          ));
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="w-100 pl-3 pr-3">
            <AddSubcontractor
              handleAddEditSubcontractor={handleAddEditSubcontractor}
              selectedTab="addEditSubcontractor"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Subcontractor;
